/**
 * @file assign
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { getKeys } from '@tencent/glue-util-types';

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('assign cannot be called with null or undefined');
  }

  return Object(val);
}

export function assign(target) {
  var res = toObject(target);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  args.forEach(function (item) {
    var source = toObject(item);
    getKeys(source).forEach(function (key) {
      var value = source[key];

      if (value === undefined) {
        return;
      }

      res[key] = value;
    });
  });
}